<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "accountContainer",
};
</script>

<style scoped></style>
